// generated by @tcg/api-client gen-client — do not edit
import type { paths } from "./schema";
import { createServiceClient, type ServiceClientOptions } from "../../create-client";

export type CatalogPaths = paths;
export const CATALOG_SERVICE = "catalog" as const;

/** Typed openapi-fetch client for the catalog service (schema `catalog`). */
export function createCatalogClient(options: ServiceClientOptions) {
  return createServiceClient<paths>("catalog", options);
}

export type CatalogClient = ReturnType<typeof createCatalogClient>;
